export const REGISTER_GOOGLE = 'REGISTER_GOOGLE'
export const REGISTER_GOOGLE_SUCCESS = 'REGISTER_GOOGLE_SUCCESS'
export const REGISTER_GOOGLE_ERROR = 'REGISTER_GOOGLE_ERROR'

export const RegisterGoogle = (data) => ({
  type: REGISTER_GOOGLE,
  payload: data
})
